/**
 * Re-authentication token utilities.
 *
 * After a successful POST /api/auth/reauth (password + TOTP when enabled),
 * the backend returns a short-lived JWT (15 min). We keep it in
 * sessionStorage so it dies with the tab, never localStorage. Sensitive
 * dealer-settings endpoints (e.g. settings mutations) include it as
 * `X-Reauth-Token` via the api interceptor.
 */
const STORAGE_KEY = "tw_reauth_token";
const STORAGE_EXP_KEY = "tw_reauth_exp";

// Vorübergehend (bis zum Live-Gang) das Passwort-Re-Auth-Gate für Einstellungen
// pausieren. Hinweis: Die Settings-Backend-Endpoints erzwingen `require_reauth`
// NICHT — das Gate ist rein im Frontend. Zum Live-Gang auf `false` setzen.
export const REAUTH_PAUSED_UNTIL_GOLIVE = true;


export function setReauthToken(token, expiresInMinutes = 15) {
    try {
        sessionStorage.setItem(STORAGE_KEY, token);
        const exp = Date.now() + expiresInMinutes * 60 * 1000;
        sessionStorage.setItem(STORAGE_EXP_KEY, String(exp));
    } catch {
        /* sessionStorage unavailable — ignore */
    }
}

export function clearReauthToken() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_EXP_KEY);
    } catch {
        /* noop */
    }
}

export function getReauthToken() {
    try {
        const token = sessionStorage.getItem(STORAGE_KEY);
        const exp = Number(sessionStorage.getItem(STORAGE_EXP_KEY) || 0);
        if (!token || !exp || Date.now() > exp) {
            clearReauthToken();
            return null;
        }
        return token;
    } catch {
        return null;
    }
}

export function isReauthValid() {
    return !!getReauthToken();
}
